import { useMemo } from "react";
import { date, number, object, string } from "yup";

export const useValidationSchema = () => {
  return useMemo(
    () =>
      object({
        quantity: number().min(0).required(),
        expiryDate: date().required(),
        reasonCategory: string().required(),
        reasonText: string().when("reasonCategory", {
          is: "OTHER",
          then: string().required(),
        }),
      }),
    [],
  );
};
